<script setup>
const offers = [
  {
    image: '/images/section/offers/support.jpg',
    title: 'offers.items.0.title',
    icon: '/icons/message.svg',
  },
  {
    image: '/images/section/offers/sales.jpg',
    title: 'offers.items.1.title',
    icon: '/icons/percents.svg',
  },
  {
    image: '/images/section/offers/integration.jpg',
    title: 'offers.items.2.title',
    icon: '/icons/branch.svg',
  },
];
</script>

<template>
  <section class="section-offers">
    <div class="container">
      <div class="section-offers__head">
        <h2 class="section-offers__title">
          <span class="section-offers__font section-offers__font--title">
            {{ $t('offers.title') }}
          </span>
        </h2>
      </div>

      <div
        class="section-offers__cards section-offers__cards--desktop hidden-mobile"
      >
        <CardOffer
          v-for="(offer, index) in offers"
          :key="index"
          :title="$t(offer.title)"
          :image="offer.image"
          :icon="offer.icon"
        />
      </div>

      <UiAccordion v-slot="{ item }" :items="offers" class="hidden-desktop">
        <CardOffer
          :title="$t(item.title)"
          :image="item.image"
          :icon="item.icon"
        />
      </UiAccordion>
    </div>
  </section>
</template>

<style scoped lang="scss">
.section-offers {
  &__head {
    margin-bottom: em(75);

    @include media-breakpoint-desktop {
      padding-inline-start: em(68);
    }

    @include media-breakpoint-mobile {
      margin-bottom: em(41);
      text-align: center;
    }
  }

  &__title {
    display: inline-block;
    padding-bottom: em(8);
    margin-bottom: em(-8);

    @include gradient-text(
      linear-gradient(90deg, $color-second-1 23.48%, $color-black 100%)
    );
  }

  &__font {
    &--title {
      font-size: em(80);
      line-height: 1;
      font-weight: $font-weight-semi-bold;

      @include media-breakpoint-mobile {
        font-size: em(30);
      }
    }
  }

  &__cards {
    &--desktop {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: em(29);

      @include media-breakpoint-mobile {
        display: block;
      }
    }
  }
}
</style>
